import React from "react";
import PendingDoctorsComponent from "./../../../components/doctor/pendingDoctors/PendingDoctors";

function PendingDoctors() {
  return <PendingDoctorsComponent />;
}

export default PendingDoctors;
